<article class="card address-card" [ngClass]="'size--' + size">
  <div>
    <span class="chip-label chip--outline chip--success float-none float-md-end mb-3" *ngIf="isDefaultAddress">
      <app-icon anchor="icon-order-processed"></app-icon>
      <span class="ps-2">{{ prefix + 'standaard-label' | fromDictionary }}</span>
    </span>
    <p class="mb-2">
      <span *ngIf="address.company">
        {{ address.company }}
        <br />
      </span>
      <span *ngIf="address.name">
        {{ address.name }}
        <br />
      </span>
      <span *ngIf="address.address1" class="d-inline-block me-1">{{ address.address1 }}</span>
      <span *ngIf="address.address2">{{ address.address2 }}</span>
      <br *ngIf="address.address1 || address.address2" />
      <span *ngIf="address.zip" class="d-inline-block me-1">{{ address.zip }}</span>
      <span *ngIf="address.city" class="d-inline-block me-1">
        <ng-container *ngIf="address.country">{{ address.city }},</ng-container>
        <ng-container *ngIf="!address.country">{{ address.city }}</ng-container>
      </span>
      <span *ngIf="address.country">{{ address.country }}</span>
      <br *ngIf="address.zip || address.city || address.country" />
      <span *ngIf="address.phone">{{ address.phone }}</span>
    </p>
  </div>

  <footer class="mt-2" *ngIf="!hideActions">
    <ul class="d-flex justify-content-between">
      <span class="d-flex flex-wrap">
        <li class="me-3">
          <a [routerLink]="['/', 'account', 'edit-address', id]" type="button" class="button button-link button--muted-light">
            <app-icon anchor="icon-edit"></app-icon>
            <span class="button__label">{{ 'bewerken' | fromDictionary }}</span>
          </a>
        </li>
        <li class="me-3">
          <button type="button" class="button button-link button--muted-light" (click)="emitAction('delete')">
            <app-icon anchor="icon-delete" *ngIf="!(loading && loadingState?.action === 'isDeleting')"></app-icon>
            <span *ngIf="loading && loadingState?.action === 'isDeleting'" class="icon-loader css-icon" title="laden"></span>
            <span class="button__label">{{ 'verwijderen' | fromDictionary }}</span>
          </button>
        </li>
      </span>
      <li class="me-3" *ngIf="!isDefaultAddress">
        <a (click)="emitAction('setDefault')" type="button" class="button button-link button--muted-light">
          <app-icon anchor="icon-order-processed" *ngIf="!(loading && loadingState?.action === 'setDefault')"></app-icon>
          <span *ngIf="loading && loadingState?.action === 'setDefault'" class="icon-loader css-icon" title="laden"></span>
          <span class="button__label">{{ prefix + 'stel-in-als-standaard' | fromDictionary }}</span>
        </a>
      </li>
    </ul>
  </footer>
</article>
